package com.fireavert.menu.data_models

import kotlinx.serialization.Serializable

@Serializable
data class NotificationResult(val number: Int? = null)